<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 mt-xl-0 pt-0 pt-md-3 pt-xl-1 pb-3 pb-md-5 pb-xl-0 shadow-lg col-12 col-lg-11"
>
  <div class="jumbotron-fluid col-12 col-md-10">
    <div class="container my-2 mx-0 shadow-lg">
      <div class="row">
        <div class="col-12">
          <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
            {{ header }}
          </h4>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div
        [hidden]="!showUserForm"
        class="card-body col-12 my-0 pt-3 mx-auto pb-4 shadow-lg"
      >
        <form [formGroup]="userForm">
          <div class="d-flex mt-0 mb-2 py-0 mx-auto">
            <div
              *ngIf="checkedClient"
              class="row"
            >
              <div class="col-12 text-left text-info h6"><strong>Selected Client Details</strong></div>
              <div class="col-6">ID: <strong>{{checkedClient.customerId}} </strong></div>
              <div class="col-6">Name: <strong>{{checkedClient.customerName}} </strong></div>
              <div class="col-6">Phone: <strong>{{checkedClient.customerPhone1}}</strong></div>
              <div class="col-6">Secret Pin: <strong>{{checkedClient.customerSecretPin}}</strong></div>
            </div>
          </div>
          <div class="d-flex mt-0 mb-2 py-0 mx-auto">
            <button
              (click)="selectFromData(dataModal, 100)"
              class="btn btn-info col-5 mx-auto"
              type="button"
            >
              Select Client
            </button>
            <button
              (click)="getStatement()"
              *ngIf="checkedClient"
              [hidden]="true"
              class="btn btn-info col-5 mx-auto"
              type="button"
            >
              Client's statement
            </button>
          </div>
          <div class="row">
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.date.valid ? 'text-info' : ''"
                for="date"
              >
                Transaction Date
                <i
                  *ngIf="fval.date.valid"
                  class="material-icons"
                >check_circle</i>
              </label>
              <div class="input-group mb-0">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i
                      class="fas fa-calendar-alt text-primary mx-auto"
                      style="size: 50px;"
                    >
                    </i>
                  </div>
                </div>
                <input
                  [bsConfig]="{ containerClass: 'theme-blue', dateInputFormat: 'MM/DD/YYYY', isAnimated: true }"
                  [ngClass]="{'is-invalid': (fval.date.touched || fval.date.dirty) && fval.date.errors}"
                  autocomplete="off"
                  bsDatepicker
                  class="form-control"
                  formControlName="date"
                  id="date"
                  placeholder="Click to select Date"
                  placement="bottom"
                  type="text"
                />
              </div>
              <div
                *ngIf="
              (fval.date.touched || fval.date.dirty) &&
              fval.date.errors?.required
            "
                class="text-danger col"
              >
                The transaction date is required!
              </div>
            </div>
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.loanPurpose.valid ? 'text-info' : ''"
                for="loanPurpose"
              >Loan Purpose<i
                  *ngIf="fval.loanPurpose.valid"
                  class="material-icons"
                >check_circle</i></label>
              <div class="input-group mb-0">
                <input
                  id="loanPurpose"
                  [ngClass]="{
                  'is-invalid':
                    (fval.loanPurpose.touched || fval.loanPurpose.dirty) &&
                    fval.loanPurpose.errors
                }"
                  autocomplete="off"
                  class="form-control"
                  formControlName="loanPurpose"
                  placeholder="Enter Loan purpose"
                  type="text"
                />
              </div>
              <div
                *ngIf="
                (fval.loanPurpose.touched || fval.loanPurpose.dirty) &&
                fval.loanPurpose.errors?.required
              "
                class="text-danger col"
              >
                The loan purpose is required!
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.cycle.valid ? 'text-info' : ''"
                for="cycle"
              >Amortization Cycle<i
                  *ngIf="fval.cycle.valid"
                  class="material-icons"
                >check_circle</i></label>
              <div class="input-group mb-0">
                <select
                  [ngClass]="{
            'is-invalid':
              (fval.cycle.touched || fval.cycle.dirty) &&
              fval.cycle.errors
          }"
                  autocomplete="off"
                  class="form-control"
                  formControlName="cycle"
                >
                  <option
                    class="place-holder-select"
                    disabled
                    hidden
                    selected
                    value=""
                  >Select Amortization Cycle</option>
                  <option
                    *ngFor="let itm of armoCycles"
                    [value]="itm.code"
                  >
                    {{ itm.name }}
                  </option>
                </select>
              </div>
              <div
                *ngIf="
            (fval.cycle.touched || fval.cycle.dirty) &&
            fval.cycle.errors?.required
          "
                class="text-danger col"
              >
                The Amortization cycle is required!
              </div>
            </div>
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.type.valid ? 'text-info' : ''"
                for="type"
              >Amortization Type<i
                  *ngIf="fval.type.valid"
                  class="material-icons"
                >check_circle</i></label>
              <div class="input-group mb-0">
                <select
                  [ngClass]="{
            'is-invalid':
              (fval.type.touched || fval.type.dirty) &&
              fval.type.errors
          }"
                  autocomplete="off"
                  class="form-control"
                  formControlName="type"
                >
                  <option
                    class="place-holder-select"
                    disabled
                    hidden
                    selected
                    value=""
                  >Select Amortization Type</option>
                  <option
                    *ngFor="let item of armoTypes"
                    [value]="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div
                *ngIf="
              (fval.type.touched || fval.type.dirty) &&
              fval.type.errors?.required
            "
                class="text-danger col"
              >
                The Amortization type is required!
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.itemRate.valid ? 'text-info' : ''"
                for="itemRate"
              >Rate<i
                  *ngIf="fval.itemRate.valid"
                  class="material-icons"
                >check_circle</i></label>
              <div class="input-group mb-0">
                <input
                  [ngClass]="{
                'is-invalid':
                  (fval.itemRate.touched || fval.itemRate.dirty) &&
                  fval.itemRate.errors
              }"
                  autocomplete="off"
                  class="level-control form-control mx-0"
                  formControlName="itemRate"
                  id="itemRate"
                  placeholder="Monthly Rate"
                  type="number"
                />
              </div>
              <div
                *ngIf="
              (fval.itemRate.touched || fval.itemRate.dirty) &&
              fval.itemRate.errors?.required
            "
                class="text-danger col"
              >
                The loan rate is required!
              </div>
            </div>
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.tenure.valid ? 'text-info' : ''"
                for="tenure"
              >Tenure
                <i
                  *ngIf="fval.tenure.valid"
                  class="material-icons"
                >check_circle</i></label>
              <div class="input-group mb-0">
                <input
                  [ngClass]="{
                    'is-invalid':
                    (fval.tenure.touched || fval.tenure.dirty) &&
                    fval.tenure.errors
                  }"
                  autocomplete="off"
                  class="level-control form-control mx-0"
                  formControlName="tenure"
                  id="tenure"
                  placeholder="Loan Tenure"
                  max="100"
                  min="0"
                  type="number"
                />
              </div>
              <div
                *ngIf="
                (fval.tenure.touched || fval.tenure.dirty) &&
                fval.tenure.errors?.required
              "
                class="text-danger col"
              >
                The loan rate is required!
              </div>
              <div
                *ngIf="
                (fval.tenure.touched || fval.tenure.dirty) &&
                fval.tenure.invalid
              "
                [ngClass]="
                fval.tenure.errors?.required ||
                fval.tenure.errors?.maxlength
                  ? 'text-danger'
                  : 'text-info'
              "
                class="col"
              >
                The loan tenure should be a maximum of 100
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.amount_to_pay.valid ? 'text-info' : ''"
                for="amount_to_pay"
              >Amount<i
                  *ngIf="fval.amount_to_pay.valid"
                  class="material-icons"
                >check_circle</i></label>
              <div class="input-group mb-0">
                <input
                  (blur)="checkLimit(fval.amount_to_pay.value)"
                  (keyup)="onKey($event)"
                  [ngClass]="{
                  'is-invalid':
                    (fval.amount_to_pay.touched || fval.amount_to_pay.dirty) &&
                    fval.amount_to_pay.errors
                }"
                  autocomplete="off"
                  class="form-control"
                  formControlName="amount_to_pay"
                  list="amount_to_pay"
                  placeholder="Enter loan amount"
                  type="text"
                />
              </div>
              <div
                *ngIf="
                (fval.amount_to_pay.touched || fval.amount_to_pay.dirty) &&
                fval.amount_to_pay.errors?.required
              "
                class="text-danger col"
              >
                The amount to loan is required!
              </div>
              <div
                *ngIf="
                (fval.amount_to_pay.touched || fval.amount_to_pay.dirty) &&
                fval.amount_to_pay.errors?.maxLength
              "
                class="text-danger col"
              >
                Please enter valid amount to be borrowed!
              </div>
              <div
                *ngIf="
                (fval.amount_to_pay.touched || fval.amount_to_pay.dirty) &&
                fval.amount_to_pay.errors?.minlength
              "
                class="text-danger col"
              >
                Please enter valid amount to be borrowed
              </div>
              <div
                *ngIf="
                (fval.amount_to_pay.touched || fval.amount_to_pay.dirty) &&
                fval.amount_to_pay.errors?.hasNumber
              "
                class="text-danger col"
              >
                Please enter valid amount to be borrowed
              </div>
            </div>
            <div class="form-group text-primary col-12 col-md-6">
              <label
                [ngClass]="fval.pin.valid ? 'text-info' : ''"
                for="pin"
              >Client's PIN<i
                  *ngIf="fval.pin.valid"
                  class="material-icons"
                >check_circle</i></label>

              <div class="input-group mb-0">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i
                      class="fas fa-lock text-primary mx-auto"
                      style="size: 50px;"
                    ></i>
                  </div>
                </div>
                <input
                  [ngClass]="{
                  'is-invalid':
                    (fval.pin.touched || fval.pin.dirty) && fval.pin.errors
                }"
                  autocomplete="off"
                  class="form-control"
                  formControlName="pin"
                  placeholder="Enter your PIN"
                  type="password"
                />
              </div>
              <div
                *ngIf="
                (fval.pin.touched || fval.pin.dirty) &&
                fval.pin.errors?.required
              "
                class="text-danger col"
              >
                The PIN is required
              </div>

              <div
                *ngIf="
                (fval.pin.touched || fval.pin.dirty) &&
                fval.pin.errors?.maxlength
              "
                class="text-danger col"
              >
                Please enter a valid pin
              </div>
              <div
                *ngIf="
                (fval.pin.touched || fval.pin.dirty) &&
                fval.pin.errors?.hasNumber
              "
                class="text-danger col"
              >
                Only digits are allowed
              </div>
              <div
                *ngIf="
                (fval.pin.touched || fval.pin.dirty) &&
                fval.pin.errors?.minlength
              "
                class="text-danger col"
              >
                Please enter a valid pin
              </div>
            </div>
          </div>
          <div class="d-flex mt-0 mb-2 py-0 mx-auto">
            <button
              (click)="saveAndNew()"
              [disabled]="!userForm.valid"
              class="btn btn-info col-5 mx-auto"
              type="submit"
            >
              Next
            </button>
            <button
              (click)="cancelForm()"
              class="btn btn-info col-5 mx-auto"
              type="button"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <!-- <div class="col-12"> -->
      <div
        [hidden]="!showGarantorForm"
        class="form-2 card-body col-12 col-md-10 mt-0 mb-2 pt-3 mx-auto pb-4 shadow-lg"
      >
        <form [formGroup]="garantorsForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  [ngClass]="garantorFval.name.valid ? 'text-info' : ''"
                  for="name"
                >Guarantor's Name<i
                    *ngIf="garantorFval.name.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    [ngClass]="{
                      'is-invalid':
                        (garantorFval.name.touched ||
                          garantorFval.name.dirty) &&
                        garantorFval.name.errors
                    }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="name"
                    placeholder="Enter Guarantor's Name"
                    type="text"
                  />
                </div>
                <div
                  *ngIf="
                    (garantorFval.name.touched || garantorFval.name.dirty) &&
                    garantorFval.name.errors?.required
                  "
                  class="text-danger col"
                >
                  The guarantor's name is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  [ngClass]="garantorFval.url.valid ? 'text-info' : ''"
                  for="url"
                >Guarantor's Image<i
                    *ngIf="garantorFval.url.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    (change)="onFileSelected($event)"
                    [ngClass]="{
                      'is-invalid':
                        (garantorFval.url.touched || garantorFval.url.dirty) &&
                        garantorFval.url.errors
                    }"
                    capture
                    class="form-control"
                    formControlName="url"
                    id="guarantorUrl"
                    src="image/*"
                    type="file"
                  />
                </div>
                <div
                  *ngIf="
                    (garantorFval.url.touched || garantorFval.url.dirty) &&
                    garantorFval.url.errors?.required
                  "
                  class="text-danger col"
                >
                  Please upload a photo of the guarantor!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  [ngClass]="
                    garantorFval.main_contact_number1.valid ? 'text-info' : ''
                  "
                  for="main_contact_number1"
                >Phone Number 1<i
                    *ngIf="garantorFval.main_contact_number1.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-phone text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    [ngClass]="{
                      'is-invalid':
                        (garantorFval.main_contact_number1.touched ||
                          garantorFval.main_contact_number1.dirty) &&
                        garantorFval.main_contact_number1.errors
                    }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="main_contact_number1"
                    id="main_contact_number1"
                    placeholder="e.g. 07XXXXXXXX"
                    type="text"
                  />
                </div>
                <div
                  *ngIf="
                    (garantorFval.main_contact_number1.touched ||
                      garantorFval.main_contact_number1.dirty) &&
                    garantorFval.main_contact_number1.errors?.required
                  "
                  class="text-danger col"
                >
                  The phone number is required!
                </div>
                <div
                  *ngIf="
                    (garantorFval.main_contact_number1.touched ||
                      garantorFval.main_contact_number1.dirty) &&
                    garantorFval.main_contact_number1.errors?.hasNumber
                  "
                  class="text-danger col"
                >
                  The phone number should be equal to 10 "digits"!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  [ngClass]="
                    garantorFval.main_contact_number2.valid ? 'text-info' : ''
                  "
                  for="main_contact_number2"
                >Phone Number 2(Optional)
                  <i
                    *ngIf="garantorFval.main_contact_number2.valid"
                    class="material-icons"
                  >check_circle</i>
                </label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-phone text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    [ngClass]="{
                      'is-invalid':
                        (garantorFval.main_contact_number2.touched ||
                          garantorFval.main_contact_number2.dirty) &&
                        garantorFval.main_contact_number2.errors
                    }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="main_contact_number2"
                    id="main_contact_number2"
                    placeholder="e.g. 07XXXXXXXX (Optional)"
                    type="text"
                  />
                </div>
                <div
                  *ngIf="
                    (garantorFval.main_contact_number2.touched ||
                      garantorFval.main_contact_number2.dirty) &&
                    garantorFval.main_contact_number2.errors?.hasNumber
                  "
                  class="text-danger col"
                >
                  The phone number should be equal to 10 "digits"!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  [ngClass]="
                    garantorFval.currentBusinesstype.valid ? 'text-info' : ''
                  "
                  for="currentBusinesstype"
                >Current Business<i
                    *ngIf="garantorFval.currentBusinesstype.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    [ngClass]="{
                      'is-invalid':
                        (garantorFval.currentBusinesstype.touched ||
                          garantorFval.currentBusinesstype.dirty) &&
                        garantorFval.currentBusinesstype.errors
                    }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="currentBusinesstype"
                    placeholder="Current business type"
                    type="text"
                  />
                </div>
                <div
                  *ngIf="
                    (garantorFval.currentBusinesstype.touched ||
                      garantorFval.currentBusinesstype.dirty) &&
                    garantorFval.currentBusinesstype.errors?.required
                  "
                  class="text-danger col"
                >
                  The current business type is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  [ngClass]="
                    garantorFval.businessLocation.valid ? 'text-info' : ''
                  "
                  for="businessLocation"
                >Business Location<i
                    *ngIf="garantorFval.businessLocation.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-map-marker-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    [ngClass]="{
                      'is-invalid':
                        (garantorFval.businessLocation.touched ||
                          garantorFval.businessLocation.dirty) &&
                        garantorFval.businessLocation.errors
                    }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="businessLocation"
                    placeholder="Enter Business location"
                    type="text"
                  />
                </div>
                <div
                  *ngIf="
                    (garantorFval.businessLocation.touched ||
                      garantorFval.businessLocation.dirty) &&
                    garantorFval.businessLocation.errors?.required
                  "
                  class="text-danger col"
                >
                  The business location is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  [ngClass]="
                    garantorFval.currentResidence.valid ? 'text-info' : ''
                  "
                  for="currentResidence"
                >Current Residence<i
                    *ngIf="garantorFval.currentResidence.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-location-arrow text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    [ngClass]="{
                      'is-invalid':
                        (garantorFval.currentResidence.touched ||
                          garantorFval.currentResidence.dirty) &&
                        garantorFval.currentResidence.errors
                    }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="currentResidence"
                    placeholder="Enter Current residence"
                    type="text"
                  />
                </div>
                <div
                  *ngIf="
                    (garantorFval.currentResidence.touched ||
                      garantorFval.currentResidence.dirty) &&
                    garantorFval.currentResidence.errors?.required
                  "
                  class="text-danger col"
                >
                  Current residence is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex mt-1 mb-2 py-0 mx-0 px-0">
                <button
                  (click)="saveAndNew()"
                  [disabled]="!garantorsForm.valid"
                  class="btn btn-info col-md-2 mx-auto"
                  type="submit"
                >
                  Save & Add
                </button>
                <button
                  (click)="saveAndNext()"
                  [disabled]="!garantorsForm.valid"
                  class="btn btn-info col-md-2 mx-auto"
                  type="submit"
                >
                  Save & Next
                </button>
                <button
                  (click)="skip()"
                  class="btn btn-info col-md-2 mx-auto"
                  type="button"
                >
                  Skip
                </button>
                <button
                  (click)="cancelForm()"
                  class="btn btn-info col-md-2 mx-auto"
                  type="button"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </form>
        <!-- </div> -->
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div
        [hidden]="!showSecurityForm"
        class="form-3 card-body mt-0 mb-2 pt-3 mx-auto pb-4 shadow-lg"
      >
        <form [formGroup]="securityForm">
          <div class="form-group text-primary">
            <label
              [ngClass]="securityFval.type.valid ? 'text-info' : ''"
              for="type"
            >Security Type<i
                *ngIf="securityFval.type.valid"
                class="material-icons"
              >check_circle</i></label>
            <div class="input-group mb-0">
              <select
                [ngClass]="{
              'is-invalid':
                (securityFval.type.touched || securityFval.type.dirty) &&
                    securityFval.type.errors
            }"
                autocomplete="off"
                class="form-control"
                formControlName="type"
              >
                <option
                  class="place-holder-select"
                  disabled
                  hidden
                  selected
                  value=""
                >Select Security Type</option>
                <option
                  *ngFor="let item of securityTypes"
                  [value]="item.securityTypeCode"
                >
                  {{item.securityTypeName}}
                </option>
              </select>
            </div>
            <div
              *ngIf="
                (securityFval.type.touched || securityFval.type.dirty) &&
                securityFval.type.errors?.required
              "
              class="text-danger col"
            >
              The security type is required!
            </div>
          </div>
          <div class="form-group text-primary">
            <label
              [ngClass]="securityFval.name.valid ? 'text-info' : ''"
              for="name"
            >Security Name<i
                *ngIf="securityFval.name.valid"
                class="material-icons"
              >check_circle</i></label>
            <div class="input-group mb-0">
              <input
                [ngClass]="{
                  'is-invalid':
                    (securityFval.name.touched || securityFval.name.dirty) &&
                    securityFval.name.errors
                }"
                autocomplete="off"
                class="form-control"
                formControlName="name"
                placeholder="Enter Security Name"
                type="text"
              />
            </div>
            <div
              *ngIf="
                (securityFval.name.touched || securityFval.name.dirty) &&
                securityFval.name.errors?.required
              "
              class="text-danger col"
            >
              The security name is required!
            </div>
          </div>
          <div class="form-group text-primary">
            <label
              [ngClass]="securityFval.location.valid ? 'text-info' : ''"
              for="location"
            >Security Location<i
                *ngIf="securityFval.location.valid"
                class="material-icons"
              >check_circle</i></label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-location-marker text-primary mx-auto"
                    style="size: 50px;"
                  ></i>
                </div>
              </div>
              <input
                [ngClass]="{
                  'is-invalid':
                    (securityFval.location.touched ||
                      securityFval.location.dirty) &&
                    securityFval.location.errors
                }"
                autocomplete="off"
                class="form-control"
                formControlName="location"
                placeholder="Enter Security Location"
                type="text"
              />
            </div>
            <div
              *ngIf="
                (securityFval.location.touched ||
                  securityFval.location.dirty) &&
                securityFval.location.errors?.required
              "
              class="text-danger col"
            >
              The security location is required!
            </div>
          </div>
          <div class="form-group text-primary">
            <label
              [ngClass]="securityFval.url.valid ? 'text-info' : ''"
              for="url"
            >Security Image<i
                *ngIf="securityFval.url.valid"
                class="material-icons"
              >check_circle</i></label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-image text-primary mx-auto"
                    style="size: 50px;"
                  ></i>
                </div>
              </div>
              <input
                (change)="onFileSelected($event)"
                [ngClass]="{
                  'is-invalid':
                    (securityFval.url.touched || securityFval.url.dirty) &&
                    securityFval.url.errors
                }"
                capture
                class="form-control"
                formControlName="url"
                id="securityUrl"
                src="image/*"
                type="file"
              />
            </div>
            <div
              *ngIf="
                (securityFval.url.touched || securityFval.url.dirty) &&
                securityFval.url.errors?.required
              "
              class="text-danger col"
            >
              Please upload a photo of the security!
            </div>
          </div>
          <div class="d-flex mt-0 mb-2 py-0 mx-0 px-0">
            <button
              (click)="saveAndNew()"
              [disabled]="!securityForm.valid"
              class="btn btn-info mx-auto"
              type="submit"
            >
              Save & Add
            </button>
            <button
              (click)="saveAndNext()"
              [disabled]="!securityForm.valid"
              class="btn btn-info mx-auto"
              type="submit"
            >
              Save & Finish
            </button>
            <button
              (click)="skip()"
              class="btn btn-info mx-auto"
              type="button"
            >
              Skip & Finish
            </button>
            <button
              (click)="cancelForm()"
              class="btn btn-info mx-auto"
              type="button"
            >
              Back
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="d-flex mt-3 mb-2 mb-xl-0 py-2 mx-auto">
      <ngx-spinner
        class="bg-info"
        size="medium"
        type="ball-scale-multiple"
      >
        <p class="text-light">Please wait...</p>
      </ngx-spinner>
      <label
        *ngIf="errored"
        class="text-danger"
      >
        <!-- <i class="material-icons">Cancel</i> -->
        <ngx-alerts></ngx-alerts>
      </label>
      <label
        *ngIf="posted"
        class="col text-info"
      >
        <!-- <i class="material-icons">check_circle</i> -->
        <ngx-alerts></ngx-alerts>
      </label>
    </div>
  </div>
</div>
<ng-template #dataModal>
  <app-data-modal
    (close)="getClose($event)"
    (result)="getResult($event)"
    [dataKind]="selectionKind"
    [data]="selectionData"
    [title]="modalTitle"
  ></app-data-modal>
</ng-template>
